import React from 'react';

interface Props {
  empresaNome: string;
  contaLabel: string;
  periodoTexto: string;
  tipoDocumental: string;
  arquivos: File[];
  enviando: boolean;
  progresso?: number;
  onCancelar: () => void;
  onConfirmar: () => void;
}

const formatarTamanho = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

// Épico "Central de Entrada de Dados", seção 12 — resumo apresentado antes de concluir a
// importação, com ação de confirmar ou voltar e revisar.
const AuditImportConfirmation: React.FC<Props> = ({
  empresaNome,
  contaLabel,
  periodoTexto,
  tipoDocumental,
  arquivos,
  enviando,
  progresso,
  onCancelar,
  onConfirmar,
}) => {
  return (
    <div className='audit-modal-backdrop' onClick={enviando ? undefined : onCancelar}>
      <div className='audit-modal' onClick={(e) => e.stopPropagation()} role='dialog' aria-modal='true'>
        <div className='audit-modal-header'>
          <h4>Confirmar Importação</h4>
          {!enviando && <button type='button' className='btn-close' aria-label='Fechar' onClick={onCancelar} />}
        </div>
        <div className='audit-modal-body'>
          <dl className='audit-confirm-list'>
            <dt>Empresa</dt>
            <dd>{empresaNome}</dd>
            <dt>Conta Contábil</dt>
            <dd>{contaLabel}</dd>
            <dt>Período</dt>
            <dd>{periodoTexto}</dd>
            <dt>Tipo</dt>
            <dd>{tipoDocumental}</dd>
            <dt>{arquivos.length > 1 ? 'Arquivos' : 'Arquivo'}</dt>
            <dd>
              {arquivos.map((f, i) => (
                <div key={i}>
                  {f.name} <span className='text-muted'>({(f.name.split('.').pop() || '').toUpperCase()} · {formatarTamanho(f.size)})</span>
                </div>
              ))}
            </dd>
          </dl>
          {enviando && (
            <div className='mt-3'>
              <div className='audit-progress-title'>Enviando arquivo — {progresso ?? 0}%</div>
              <div className='audit-progress-bar-track'>
                <div className='audit-progress-bar-fill' style={{ width: `${progresso ?? 0}%` }} />
              </div>
            </div>
          )}
        </div>
        <div className='audit-modal-footer'>
          <button type='button' className='btn btn-sm btn-light' disabled={enviando} onClick={onCancelar}>
            Voltar e Revisar
          </button>
          <button type='button' className='btn btn-sm btn-primary' disabled={enviando} onClick={onConfirmar}>
            {enviando && <span className='spinner-border spinner-border-sm me-2' />}
            Confirmar Importação
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuditImportConfirmation;
